import { render, staticRenderFns } from "./SettingTextInput.vue?vue&type=template&id=42371b2a&scoped=true&"
import script from "./SettingTextInput.vue?vue&type=script&lang=js&"
export * from "./SettingTextInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingTextInput.vue?vue&type=style&index=0&id=42371b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42371b2a",
  null
  
)

export default component.exports